export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

const getFirstPositiveEscalationAmount = (escalations) => {
    if (!Array.isArray(escalations)) {
        return 0;
    }

    const firstPositiveEscalation = escalations.find(
        (escalation) => parseFloat(escalation?.amount) > 0
    );

    return firstPositiveEscalation ? parseFloat(firstPositiveEscalation.amount) : 0;
};

export const columns = [
    {
        dataField: 'name',
        text: 'Fine Name',
        sort: true,
        headerStyle: () => { return { minWidth: '30%', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'ruleTypeName',
        text: 'Rule Type',
        sort: true,
        headerStyle: () => { return { width: '20%', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'reasonTypeName',
        text: 'Reason Type',
        sort: true,
        headerStyle: () => { return { width: '20%', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'escalations',
        text: 'Amount',
        sort: true,
        formatter: (cell, row) => {
            return `$${getFirstPositiveEscalationAmount(cell).toFixed(2)}`;
        },
        sortFunc: (a, b, order) => {
            const amountA = getFirstPositiveEscalationAmount(a);
            const amountB = getFirstPositiveEscalationAmount(b);

            if (order === 'asc') {
                return amountA - amountB;
            }

            return amountB - amountA;
        },
        headerStyle: () => { return { width: '15%', ...headerStyle() }; },
        style: columnStyle
    },
];

export const sorting = [{
    dataField: 'instance',
    order: 'asc'
}];